import React from "react";
import { useTranslation } from "react-i18next";
import "./CSS/QueueCard.css";

const QueueCard = ({ queue, queueKpi, agents }) => {
  const { t } = useTranslation();

  if (!queueKpi) {
    return null;
  }

  const queueName = queue.queueName || queue.name || queue.RowKey;

  // Calculer les états des agents
  const agentStates = {
    ready: 0,
    busy: 0,
    break: 0,
    offline: 0
  };

  agents.forEach(agent => {
    const state = agent.state?.toLowerCase() || "offline";
    if (state.includes("ready") || state.includes("available")) {
      agentStates.ready++;
    } else if (state.includes("busy") || state.includes("oncall")) {
      agentStates.busy++;
    } else if (state.includes("break") || state.includes("pause")) {
      agentStates.break++;
    } else {
      agentStates.offline++;
    }
  });

  return (
    <div className="queue-card">
      <div className="queue-card-header">
        <h4>{queueName}</h4>
      </div>

      <div className="queue-card-body">
        {/* KPI Section */}
        <div className="queue-kpi-section">
          <div className="kpi-mini-item today">
            <span className="kpi-mini-label">{t("REALTIME.TODAY_CALLS")}</span>
            <span className="kpi-mini-value">{queueKpi.todayCalls || 0}</span>
          </div>
          <div className="kpi-mini-item live">
            <span className="kpi-mini-label">{t("REALTIME.LIVE_CALLS")}</span>
            <span className="kpi-mini-value">{queueKpi.callsInQueue || 0}</span>
          </div>
          <div className="kpi-mini-item waiting">
            <span className="kpi-mini-label">{t("REALTIME.TASKS_IN_QUEUE")}</span>
            <span className="kpi-mini-value">{queueKpi.tasksInQueue || 0}</span>
          </div>
          <div className="kpi-mini-item avg-wait">
            <span className="kpi-mini-label">{t("REALTIME.AVG_WAIT_TIME")}</span>
            <span className="kpi-mini-value">{queueKpi.avgWaitTime || "00:00:00"}</span>
          </div>
          <div className="kpi-mini-item max-wait">
            <span className="kpi-mini-label">{t("REALTIME.MAX_WAIT_TIME")}</span>
            <span className="kpi-mini-value">{queueKpi.maxWaitTime || "00:00:00"}</span>
          </div>
          <div className="kpi-mini-item sla">
            <span className="kpi-mini-label">{t("REALTIME.SLA_PERCENTAGE")}</span>
            <span className="kpi-mini-value">{queueKpi.sla || 0}%</span>
          </div>
        </div>

        {/* Agent States Section */}
        <div className="queue-agents-section">
          <h5>{t("REALTIME.AGENTS")} ({agents.length})</h5>
          <div className="agent-states-grid">
            <div className="agent-state-item ready">
              <span className="agent-state-icon">🟢</span>
              <span className="agent-state-label">{t("REALTIME.READY_AGENTS")}</span>
              <span className="agent-state-count">{agentStates.ready}</span>
            </div>
            <div className="agent-state-item busy">
              <span className="agent-state-icon">🔴</span>
              <span className="agent-state-label">{t("REALTIME.BUSY_AGENTS")}</span>
              <span className="agent-state-count">{agentStates.busy}</span>
            </div>
            <div className="agent-state-item break">
              <span className="agent-state-icon">🟡</span>
              <span className="agent-state-label">{t("REALTIME.BREAK_AGENTS")}</span>
              <span className="agent-state-count">{agentStates.break}</span>
            </div>
            <div className="agent-state-item offline">
              <span className="agent-state-icon">⚫</span>
              <span className="agent-state-label">{t("REALTIME.OFFLINE_AGENTS")}</span>
              <span className="agent-state-count">{agentStates.offline}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QueueCard;
